import React from "react";
import { Modal, Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import "./modal_confirm_item_ready.css";

interface InsufficientItem {
    item_code: string;
    item_name: string;
    required_qty: number;
    available_qty: number;
}

interface ModalConfirmItemReadyProps {
    visible: boolean;
    insufficientItems: InsufficientItem[];
    onConfirm: () => void;
    onCancel: () => void;
}

const ModalConfirmItemReady: React.FC<ModalConfirmItemReadyProps> = ({
    visible,
    insufficientItems,
    onConfirm,
    onCancel,
}) => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    return (
        <Modal
            title={
                <span style={{ display: 'flex', alignItems: 'center' }}>
                    <ExclamationCircleOutlined style={{ color: '#faad14', marginRight: 8 }} />
                    Konfirmasi Ketersediaan Stok
                </span>
            }
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>Tidak, Batalkan</Button>,
                <Button key="confirm" type="primary" onClick={onConfirm}>Ya, Lanjutkan</Button>,
            ]}
            width={600}
        >
            <div id="i8wp" style={transformStyle}>
                <div className="gjs-grid-row" id="iwfq">
                    <div className="gjs-grid-column" id="ifri">
                        <div>
                            <p>Beberapa Item tidak mencukupi di bawah ini:</p>
                            <ul>
                                {insufficientItems.map((item: InsufficientItem, index: number) => (
                                    <li key={index}>
                                        {item.item_code} - {item.item_name}: Dibutuhkan {item.required_qty}, Tersedia {item.available_qty}
                                    </li>
                                ))}
                            </ul>
                            <p>Apakah Anda ingin melanjutkan proses?</p>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ModalConfirmItemReady;